import React, { useState, useMemo } from 'react';
import { useIntl } from 'react-intl';

import * as Client from 'api/client';
import { useToast } from 'providers/Toast';
import { useAuth } from 'providers/Auth';
import Context from './Context';
import { useTimer } from 'hooks/useTimer';
import get from 'lodash.get';

const verifyState = {
  UNVERIFY: 'UNVERIFY',
  VERIFYING: 'VERIFYING',
  VERIFIED: 'VERIFIED',
};

function CountDown({ endtime = 0, handleClearTime }) {
  const intl = useIntl();
  const timer = useTimer(endtime);
  if (timer <= 0) {
    handleClearTime();
    return '';
  }

  const remainTime = Math.floor(timer / 60) + ':' + Math.floor(timer % 60);
  return intl.formatMessage({ id: 'cool_down_time' }, { time: remainTime });
}

const Provider = ({ children }) => {
  const { auth, client } = useAuth();
  const { danger } = useToast();
  const [timeout, setVerifyTimeout] = useState();
  const [status, setStatus] = useState(verifyState.VERIFIED);
  const [verifyPhoneNumber, setVerifyPhoneNumber] = useState(client.phone);
  const intl = useIntl();

  const sendSms = async (phone) => {
    const sendSmsResp = await Client.sendSms(phone);
    console.log(sendSmsResp);
    if (sendSmsResp.data) {
      setVerifyPhoneNumber(phone);
      setVerifyTimeout(
        Math.min(new Date(sendSmsResp.data.expiredTime).getTime() / 1000),
      );
      setStatus(verifyState.VERIFYING);
    } else danger(intl.formatMessage({ id: 'sms_fail_msg' }));

    return sendSmsResp;
  };

  const verifySms = async (phone, phoneVerify) => {
    const verify = await Client.verifySms(phone, auth.userId, phoneVerify);
    console.log(verify);
    if (verify.err) {
      danger(
        get(
          verify,
          'err.message',
          intl.formatMessage({ id: 'phone_verify_error' }),
        ),
      );
      if (verify.err.code === '4000601') {
        setStatus(verifyState.UNVERIFY);
        setVerifyTimeout(0);
      }
    } else {
      setStatus(verifyState.VERIFIED);
      setVerifyTimeout(0);
    }
    return verify;
  };

  const handleClearTime = () => {
    setStatus(verifyState.UNVERIFY);
  };

  const verifyHelperText = (() => {
    switch (status) {
      case verifyState.UNVERIFY:
        return intl.formatMessage({ id: 'verify_phone' });
      case verifyState.VERIFYING:
        if (timeout)
          return (
            <CountDown endtime={timeout} handleClearTime={handleClearTime} />
          );
        else return '';
      case verifyState.VERIFIED:
        return intl.formatMessage({ id: 'verify_phone_success' });
      default:
        return '';
    }
  })();

  const disabled = useMemo(() => {
    return status === verifyState.VERIFIED;
  }, [status]);

  const props = {
    sendSms,
    verifySms,
    setStatus,
    status,
    setVerifyTimeout,
    timeout,
    setVerifyPhoneNumber,
    verifyPhoneNumber,
    disabled,
    verifyHelperText,
  };
  return <Context.Provider value={{ ...props }}>{children}</Context.Provider>;
};

export default Provider;
